import React, { useContext } from 'react';
import { Dropdown as BootstrapDropdown, Accordion as BootstrapAccordion, Card as BootstrapCard } from 'react-bootstrap';
import AccordionContext from 'react-bootstrap/AccordionContext';
import { useAccordionToggle } from 'react-bootstrap/AccordionToggle';
import { X } from 'react-feather';
import { Button, Subhead2, H6 } from '../../../theme/styles';
import '../Dropdown.css';
import { translate } from '../../../translations';

/*
 * Example options props used in <DropdownAction />
 * const options = [
 *    {
 *      key: "1",
 *      text: "Edit Location",
 *      icon: (<Edit2 color={sanitizePropertyValue('--tertiaryText')} size={18} />),
 *      onClick: this.testActionClick,
 *      disabled: true/false,
 *      leftIcon: true/false,
 *    },
 *    {
 *      key: "2",
 *      text: "Export",
 *      icon: (<Download color={sanitizePropertyValue('--tertiaryText')} size={18} />),
 *      onClick: this.testActionClick,
 *      disabled: true/false,
 *      leftIcon: true/false,
 *    },
 *
 */

/* utility functional class to support the dropdown caret in subMenus */
export function DropdownAccordionHelper({ children, eventKey, callback }) {
    const currentEventKey = useContext(AccordionContext);
    const onClickWrapper = useAccordionToggle(eventKey, () => callback && callback(eventKey));
    const isCurrentEventKey = currentEventKey === eventKey;

    return (
        <div onClick={onClickWrapper} className={isCurrentEventKey ? 'show' : null} role="button" tabIndex="0">{children}</div>
    );
}
export class DropdownAction extends React.PureComponent {
    renderIcon = (icon) => (
        <div className="iconButton">
            {icon}
        </div>
    );

    renderDivider = (thinFlag, key, index) => ((thinFlag) ? <div key={index} className="dropdown-divider-thin" /> : <div key={key} className="dropdown-divider-thick" />);

    renderIndividualMenu = (option, popup, index) => {
        if (option.type === 'divider') {
            return this.renderDivider(false, option.key, index);
        }
        if (option.type === 'divider-thin') {
            return this.renderDivider(true, option.key, index);
        }
        if (option.subOptions && Array.isArray(option.subOptions)) {
            return this.renderMenuItemWithSubs(option, popup, index);
        }
        return this.renderMenuItem(option, popup, index);
    };

    subOptionsHamburgerMap = (option) => (
        <div
            key={option.key}
            tabIndex="0"
            role="link"
            onClick={() => { window.location = option.url; }}
        >
            <span
                style={H6}
                className={
                    (option.url === window.location.pathname)
                        ? 'inline-block currentActiveSubOption' : 'inline-block notActiveSubOption'
                }
            >
                {translate(option.translationKey)}
            </span>
        </div>
    );

    renderMenuItemWithSubs = (option, popup, index) => (
        <BootstrapAccordion
            key={index}
            className={[
                'dropdownActionContainer',
                option.currentActive ? 'currentActive' : null,
            ]}
            defaultActiveKey={option.currentActive ? option.key : null}
        >
            <BootstrapCard>
                <DropdownAccordionHelper eventKey={option.key}>
                    <BootstrapAccordion.Toggle as={BootstrapCard.Header} eventKey={option.key}>
                        {this.renderMenuItem(option, popup)}
                    </BootstrapAccordion.Toggle>
                </DropdownAccordionHelper>
                <BootstrapAccordion.Collapse eventKey={option.key}>
                    <BootstrapCard.Body>
                        {option.subOptions.map(this.subOptionsHamburgerMap)}
                    </BootstrapCard.Body>
                </BootstrapAccordion.Collapse>
            </BootstrapCard>
        </BootstrapAccordion>
    );

    renderMenuItem = (option, popup, index) => (
        <div
            key={index}
            className={
                ['dropdownActionContainer',
                    popup ? null : 'defaultItem',
                    option.currentActive ? 'currentActive' : null,
                    option.lastOption ? 'lastOption' : null,
                ].join(' ')
            }
            style={Button}
            role="button"
            tabIndex={option.key}
            onClick={option.onClick}
            disabled={option.disabled}
        >
            {option.leftIcon && this.renderIcon(option.icon)}
            <span className="actionText" style={Subhead2}>
                {option.text}
            </span>
            {!option.leftIcon && this.renderIcon(option.icon)}
        </div>
    );

    renderDropdownCloseButton = (toggleClose) => (
        <X
            role="button"
            tabIndex={0}
            className="dropdownCloseButton"
            alt="Close Button"
            onClick={toggleClose}
        />
    );

    render() {
        const {
            toggleClose,
            options,
            popup,
        } = this.props;

        return (
            <BootstrapDropdown.Menu className={['dropdownActionMenu overlay-scrollbar-thin', popup ? 'topLeftPosition' : null].join(' ')}>
                {toggleClose && this.renderDropdownCloseButton(toggleClose)}
                {options && options.map((option, index) => this.renderIndividualMenu(option, popup, index))}
            </BootstrapDropdown.Menu>
        );
    }
}

export default DropdownAction;
